import React, { Component } from 'react'
import { TextField, Fab } from '@material-ui/core'
import { DialogPesquisa } from 'scorpion-core'
import SearchIcon from '@material-ui/icons/Search';

import View from 'react-flexbox'

export default class Sel extends Component {
    constructor(props) {
        super(props)
        this.selecionar = this.selecionar.bind(this)
    }
    selecionar(item) {
        this.dialog.hide();
        this.props.input.onChange(this.props.itemToValue(item))
    }
    render() {
        const {
            input: { value, onChange },
            meta: { touched, error },
            label,
            pesquisa,
            toStringItem,
            itemToValue,
            ...otherProps
        } = this.props;

        let error1 = touched && error ? true : false;

        let telaPesquisaInjetada = null;
        if (this.props.pesquisa) {
            telaPesquisaInjetada = React.cloneElement(pesquisa, {
                selecionar: this.selecionar
            })
        }
        return (
            <View>
                <TextField
                    disabled
                    error={error1}
                    label={label}
                    value={toStringItem(value)}

                    helperText={error1 ? error : ""}
                    fullWidth
                    style={{ marginBottom: 15 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    {...otherProps}
                />

                <Fab color="primary"
                    size="small"
                    onClick={() => this.dialog.show()}  >

                    <SearchIcon />
                </Fab>
                {pesquisa && <DialogPesquisa forwardedRef={node => this.dialog = node} > {telaPesquisaInjetada}</DialogPesquisa>}
            </View>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/editor/Sel.js